import { Maybe, fromNullable, nothing } from 'maybeasy';
import { ResourceFor } from '../../../../../../../../Resourceable';
import { ClientExperienceResourceArray, ExperienceResourceArray } from '../../../Types';

type DetailsResource = ResourceFor<'/experience_details', 'get', 200>;

// Fields that the API returns but aren't in the OpenAPI spec — accessed via runtime cast.
// Runtime values may be absent; the `?? nothing()` fallback at the call site handles that.
interface ExtendedRawPayload {
  total_weeks: Maybe<number>;
  school_partner_logo_url: Maybe<string>;
}

const mapDescriptionToId = (resource: DetailsResource): Map<number, string> =>
  resource.payload.details.reduce(
    (acc, { id, description }) => acc.set(id, description),
    new Map<number, string>(),
  );

export const addDescriptionToExperiences = (
  experiences: ExperienceResourceArray,
  resource: DetailsResource,
): ClientExperienceResourceArray =>
  experiences.map((experience) => {
    const rawExtended = experience.payload as unknown as ExtendedRawPayload;
    return {
      ...experience,
      payload: {
        ...experience.payload,
        description: fromNullable(mapDescriptionToId(resource).get(experience.payload.id)),
        total_weeks: rawExtended.total_weeks ?? nothing(),
        school_partner_logo_url: rawExtended.school_partner_logo_url ?? nothing(),
      },
    };
  });
